/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialClassStudentEditorViewModel } from "../types/CourseFinancialClassStudentEditorViewModel.ts";

export const courseFinancialClassStudentEditorViewModelSchema = z.object({
  classStudentId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da turma. Obrigatório. A turma precisa pertencer ao curso do plano e não pode já estar vinculada.",
      ),
  ),
}) as unknown as ToZod<CourseFinancialClassStudentEditorViewModel>;
